// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-btn[data-v-58c287d4],.v-card[data-v-58c287d4]{border-radius:8px}.back[data-v-58c287d4]{background-color:#173148;background-size:cover}", ""]);
// Exports
module.exports = exports;
